import React, { useCallback, useState } from 'react'
import { useDispatch } from 'react-redux'

import { strings } from '@constants'
import { addAddressToOrganisation } from '@data/conn/put/organisation'
import { showLoader, showToast } from '@data/state/action'
import { toggleDrawer } from '@data/state/action/root'
import { DrawerBodyWrapper, DrawerFooterWrapper, TOAST_TYPE } from '@base'
import { Button } from '@baseV2'
import AddAddress from '@pages/Admin/OrgsAndUsers/Organisation/DrawerComponents/AddAddress'

import { InputsWrapper } from '../styles'

const AddOrgAddress = ({ orgId, update }) => {
	const dispatch = useDispatch()
	const [address, setAddress] = useState({})
	const [addressReady, setAddressReady] = useState(false)

	const addressCb = useCallback(({ address: addr, enableButton }) => {
		if (addr) setAddress(addr)
		if (enableButton !== undefined) setAddressReady(enableButton)
	}, [])

	const addAddressHandler = () => {
		if (!addressReady) return
		dispatch(showLoader(true))
		addAddressToOrganisation(address, orgId)
			.then(() => {
				dispatch(showToast(true, 'Successfully added a new address', { type: TOAST_TYPE.SUCCESS }))
				dispatch(toggleDrawer(false))
				update?.()
			})
			.catch((err) => {
				console.log(err)
				dispatch(showToast(true, 'Error while adding a new address', { type: TOAST_TYPE.ERROR }))
			})
			.finally(() => dispatch(showLoader(false)))
	}

	return (
		<>
			<DrawerBodyWrapper>
				<InputsWrapper>
					<AddAddress addressCb={addressCb} />
				</InputsWrapper>
			</DrawerBodyWrapper>
			<DrawerFooterWrapper>
				<Button color='primary' disabled={!addressReady} onClick={addAddressHandler}>
					{strings('add_address')}
				</Button>
			</DrawerFooterWrapper>
		</>
	)
}

export default AddOrgAddress
